import { FaArrowLeft, FaEllipsisH, FaSearch } from 'react-icons/fa';
import { SiFacebook } from 'react-icons/si';

import { BrandColors } from 'constants/brand-colors';

import ariaPhoto from 'assets/avatars/facebook.jpg';

import { SOCIAL_ICON_MD_PX, SOCIAL_ICON_SM_PX } from '../constants';
import * as styled from '../styles/social-bios';
import { AnimatedLinkBox } from './animated-link-box';

const COVER_TILES = [
  'linear-gradient(135deg, #1F2937, #4B5563)',
  'linear-gradient(135deg, #B91C1C, #F59E0B)',
  'linear-gradient(135deg, #6D28D9, #EC4899)',
  'linear-gradient(135deg, #0F766E, #34D399)',
];

export const FacebookCard = ({
  initials,
  name,
  profession,
  slug,
  phase,
  enterDelay,
}: Landing.SocialBioCardContent & {
  phase: Landing.SocialBioPhase;
  enterDelay: number;
}) => (
  <styled.Card $isGood={phase === 'good'}>
    <styled.ChromeBar>
      <FaArrowLeft size={SOCIAL_ICON_MD_PX} />
      <styled.ChromeSpacer />
      <styled.ChromeIconCluster>
        <FaSearch size={SOCIAL_ICON_MD_PX} />
        <FaEllipsisH size={SOCIAL_ICON_MD_PX} />
      </styled.ChromeIconCluster>
    </styled.ChromeBar>
    <styled.FbCover>
      {COVER_TILES.map((gradient, index) => (
        <styled.FbCoverTile key={index} $gradient={gradient} />
      ))}
    </styled.FbCover>
    <styled.FbAvatarOverlap>
      <styled.FbAvatarRing>
        <styled.Avatar $size={5.4} $photoUrl={ariaPhoto}>
          {initials}
        </styled.Avatar>
      </styled.FbAvatarRing>
    </styled.FbAvatarOverlap>
    <styled.FbNameBlock>
      <styled.FbName>{name}</styled.FbName>
      <styled.FbStats>12k followers · 312 following · 80 posts</styled.FbStats>
    </styled.FbNameBlock>
    <styled.FbBio>
      <styled.FbCreatorRow>
        <SiFacebook size={SOCIAL_ICON_SM_PX} color={BrandColors.facebook} />
        {profession}
      </styled.FbCreatorRow>
      <AnimatedLinkBox phase={phase} slug={slug} enterDelay={enterDelay} />
    </styled.FbBio>
    <styled.FbActionRow>
      <styled.FbPrimary>Follow</styled.FbPrimary>
      <styled.FbSecondary>Subscribe</styled.FbSecondary>
    </styled.FbActionRow>
    <styled.FbTabRow>
      <styled.FbTab $active>Reels</styled.FbTab>
      <styled.FbTab>Photos</styled.FbTab>
      <styled.FbTab>About</styled.FbTab>
    </styled.FbTabRow>
  </styled.Card>
);
